import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PosterMakeComponent } from './make/poster-make.component';
import { PosterListComponent } from './list/poster-list.component';
import { HowToUseComponent } from './how-to-use/how-to-use.component';
import { SetFontComponent } from './make/set-font/set-font.component';
import { CommonModule } from '../common/common.module';
import { AppRoutingModule } from '../app.routes';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule,  AppRoutingModule, CommonModule],
    declarations: [PosterMakeComponent, PosterListComponent, HowToUseComponent, SetFontComponent],
    exports : []
})
export class PosterModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/poster/poster.module.ts